"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeOffIcon = exports.VolumeOnIcon = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var js_util_1 = require("@giphy/js-util");
var react_1 = __importStar(require("react"));
var _1 = __importDefault(require("."));
var VideoContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    height: 100%;\n    width: 100%;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    height: 100%;\n    width: 100%;\n"])));
var VideoStyled = styled_1.default(_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 100%;\n    display: inline-block;\n    object-fit: fill;\n"], ["\n    height: 100%;\n    display: inline-block;\n    object-fit: fill;\n"])));
var Button = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: 5px;\n    right: 10px;\n"], ["\n    position: absolute;\n    top: 5px;\n    right: 10px;\n"])));
var DebugButton = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: black;\n    color: white;\n    padding: 10px;\n    position: absolute;\n    top: 0;\n    left: 0;\n"], ["\n    background: black;\n    color: white;\n    padding: 10px;\n    position: absolute;\n    top: 0;\n    left: 0;\n"])));
exports.VolumeOnIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 38 : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c;
    return (react_1.default.createElement("svg", { onClick: onClick, height: size, viewBox: "0 0 115 115", width: size, xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { fill: "#FFF", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M59.48 26.507v56.986c0 .68-.305 1.148-.914 1.405-.703.211-1.253.094-1.651-.351L40.824 66.88H29.51c-.422 0-.78-.146-1.072-.439A1.458 1.458 0 0 1 28 65.37V44.607c0-.422.146-.779.44-1.072.292-.292.65-.439 1.07-.439h11.314l16.09-17.643c.399-.445.95-.562 1.652-.351.609.257.913.726.913 1.405z" }),
            react_1.default.createElement("path", { d: "M69.468 67.346l-2.837-6.4A6.501 6.501 0 0 0 70.5 55a6.501 6.501 0 0 0-3.855-5.94l2.854-6.392A13.5 13.5 0 0 1 77.5 55a13.5 13.5 0 0 1-8.032 12.346z", fillRule: "nonzero" }),
            react_1.default.createElement("path", { d: "M76.328 78.321l-2.838-6.4A18.503 18.503 0 0 0 84.5 55c0-7.373-4.351-13.95-10.968-16.903l2.853-6.392A25.502 25.502 0 0 1 91.5 55a25.502 25.502 0 0 1-15.172 23.321z", fillRule: "nonzero" }))));
};
exports.VolumeOffIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 38 : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c;
    return (react_1.default.createElement("svg", { onClick: onClick, height: size, viewBox: "0 0 115 115", width: size, xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { fill: "#FFF", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M90.853 62.002a.637.637 0 0 1 0 .815l-4.036 4.036a.637.637 0 0 1-.815 0L79 59.851l-7.002 7.002a.637.637 0 0 1-.815 0l-4.036-4.036a.637.637 0 0 1 0-.815L74.149 55l-7.002-7.002a.637.637 0 0 1 0-.815l4.036-4.036a.637.637 0 0 1 .815 0L79 50.149l7.002-7.002a.637.637 0 0 1 .815 0l4.036 4.036a.637.637 0 0 1 0 .815L83.851 55l7.002 7.002zM59.48 26.507v56.986c0 .68-.305 1.148-.914 1.405-.703.211-1.253.094-1.651-.351L40.824 66.88H29.51c-.422 0-.78-.146-1.072-.439A1.458 1.458 0 0 1 28 65.37V44.607c0-.422.146-.779.44-1.072.292-.292.65-.439 1.07-.439h11.314l16.09-17.643c.399-.445.95-.562 1.652-.351.609.257.913.726.913 1.405z" }))));
};
var DebugUI = function (_a) {
    var toggleMute = _a.toggleMute, muted = _a.muted, mutedByBrowser = _a.mutedByBrowser;
    return (react_1.default.createElement(DebugButton, null,
        react_1.default.createElement("div", { onClick: function (e) {
                e.preventDefault();
                toggleMute();
            } },
            "click box to ",
            muted ? 'unmute' : 'mute',
            react_1.default.createElement("br", null),
            muted ? 'user muted' : 'user not muted',
            react_1.default.createElement("br", null),
            mutedByBrowser ? 'muted by browser' : 'not muted by browser')));
};
var VolumeButton = function (_a) {
    var muted = _a.muted, toggleMute = _a.toggleMute, mutedByBrowser = _a.mutedByBrowser, isHovered = _a.isHovered;
    return (react_1.default.createElement(Button, { onClick: function (e) {
            e.preventDefault();
            toggleMute();
        } }, muted || mutedByBrowser || !isHovered ? react_1.default.createElement(exports.VolumeOffIcon, null) : react_1.default.createElement(exports.VolumeOnIcon, null)));
};
var VideoOverlay = function (_a) {
    var gif = _a.gif, isHovered = _a.isHovered, width = _a.width;
    var _b = react_1.useState(undefined), muted = _b[0], setMuted = _b[1];
    var _c = react_1.useState(false), mutedByBrowser = _c[0], setMutedByBrowser = _c[1];
    var toggleMute = function () {
        if (mutedByBrowser) {
            setMutedByBrowser(false);
            setMuted(false);
        }
        else {
            setMuted(!muted);
        }
    };
    var props = { toggleMute: toggleMute, muted: muted, mutedByBrowser: mutedByBrowser };
    return (react_1.default.createElement(VideoContainer, null,
        isHovered && (react_1.default.createElement(VideoStyled, { gif: gif, key: gif.id, loop: true, muted: muted, width: width, onMuted: setMutedByBrowser })),
        js_util_1.Logger.ENABLED ? react_1.default.createElement(DebugUI, __assign({}, props)) : react_1.default.createElement(VolumeButton, __assign({}, props, { isHovered: isHovered }))));
};
exports.default = VideoOverlay;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=video-overlay.js.map